import React, { useState } from "react";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import CustomTitleAndSubTitle from "../myOrders/customTitleAndSubTitle";
import CustomBuyForMeButtonOrders from "../ordersForBuyForMe/customOrderBuyButton";
import CustomBannerTransparent from "./transpaerntBanner";
import MoreDetailsPopup from "../ordersForBuyForMe/MoreDetailsPopup";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";


const CustomOrdersShipments = ({ item, selectedCartIds, onSelectCart }) => {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const currencySymbol = getCurrencyAndLanguageSymbol();
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  // console.log(selectedCartIds)
  return (
    <div className="w-full p-4 bg-white border border-gray-400 ">
      <div className="w-full">
      <CustomBannerTransparent
          orderNumber={item?.referenceCode}
          cartId={item?._id}
          isSelected={selectedCartIds.includes(item?._id)}
          onSelect={onSelectCart}
        />
        
        {/* Display Disktop */}
        <div className="justify-between hidden md:flex">
          <span className="w-1/3">
            <CustomTitleAndSubTitle
              title={t("from")}
              subTitle={item?.area ==="67dfef4a100f542a2c700c04" ? t("Turkey") : t("Europa")}
            />
          </span>
          <span className='flex justify-center w-1/3'>

            <CustomTitleAndSubTitle
              title={t("PackagePrice")}
              subTitle={`${roundToTwo(Number(item?.totalPackingFees)) || "0.00"}`}
              currency={currencySymbol}
            />
          </span>
          <span className='flex justify-end w-1/3'>
          {item.isPacking ?
            <CustomTitleAndSubTitle
              title={t("WeightAfterPackaging")}
              subTitle={`${item?.totalWeightAfterPacking || "0"} `}
              currency={t("kg")}
            />
            :
            <CustomTitleAndSubTitle
              title={t("weight")}
              subTitle={`${item?.totalWeight || "0"} `}
              currency={t("kg")}
            />
          }
          </span>
        </div>

        {/* Mobile view */}
        <div className="flex justify-between w-full mb-3 md:hidden md:block">
          <CustomTitleAndSubTitle
            title={t("from")}
            subTitle={item?.area ==="67dfef4a100f542a2c700c04" ? t("Turkey") : t("Europa")}
          />
          <CustomTitleAndSubTitle
            title={t("PackagePrice")}
            subTitle={`${roundToTwo(Number(item?.totalPackingFees)) || "0.00"} `}
            currency={currencySymbol}
          />

          
          
        </div>

        <div className="flex justify-between w-full md:hidden md-block">
          {
            item.isPacking ?
            <CustomTitleAndSubTitle
              title={t("WeightAfterPackaging")}
              subTitle={`${item?.totalWeightAfterPacking || "0"} `}
              currency={t("kg")}
            />
            :
            <CustomTitleAndSubTitle
              title={t("weight")}
              subTitle={`${item?.totalWeight || "0"} `}
              currency={t("kg")}
            />
          }
        </div>
      </div>

      <div className="flex flex-wrap gap-3 mt-5">
        {item?.products?.map((product, index) => (
          <img
            key={index}
            src={product.img}
            alt={`product-${index}`}
            className="object-cover w-20 h-20 rounded-md shadow-md"
          />
        ))}
      </div>
      
        {item.isPacking &&    
          <div className="flex justify-end">
            <CustomBuyForMeButtonOrders
              onClick={() => setShowPopup(true)}
              children={t("packaging_details")}
              icon={CreditCardIcon}
              textColor="text-black"
              iconColor="text-black"
            />
          </div>
        }

      {showPopup && (
        <MoreDetailsPopup referenceCode={item.referenceCode} status={item.status} cart={item} imgCart={item?.img} cartIsPacking={true} onClose={() => setShowPopup(false)} />
      )}
    </div>
  );
};

export default CustomOrdersShipments;
